import CustomInput from '../../reusable/input';
import { inviteEmailSchema } from '../../../schema/email_schema';
import { Box, Button } from '@mui/material';
import { Form, Formik } from 'formik';

const SMSFieldComponent = ({ onCancelHandler }: { onCancelHandler: () => void }) => {
    const initialValues: {
        phone: string;
        message: string;
    } = {
        phone: '',
        message: ''
    };

    const onSubmitHandler = (values: {
        phone: string;
        message: string;
    }) => {
        console.log(values);
    };

    return <Box display="flex" flexDirection="column" gap={2}>
        <Formik
            initialValues={initialValues}
            validationSchema={inviteEmailSchema}
            onSubmit={onSubmitHandler}
        >
            {({ values, errors, touched, handleChange, handleBlur }) => (
                <Form>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <CustomInput
                            type="phone"
                            value={values.phone}
                            onChangeForPhone={handleChange('phone')}
                            onBlur={handleBlur('phone')}
                            error={touched.phone && errors.phone}
                            fullWidth
                            label="To"
                            placeholder="201-555-0123"
                            variant="outlined"
                            disabled={false}
                        />
                        <CustomInput
                            type="textarea"
                            name="message"
                            label="Message"
                            onBlur={handleBlur('message')}
                            placeholder="Type here"
                            disabled={false}
                            error={touched.message && Boolean(errors.message)}
                            value={values.message}
                            onChange={handleChange('message')}
                            fullWidth
                        />
                        <Box display="flex" gap={2}>
                            <Button variant="outlined" size="large" fullWidth color="secondary" onClick={onCancelHandler}>
                                Cancel
                            </Button>
                            <Button variant="contained" size="large" fullWidth onClick={() => console.log('')}>
                                Send
                            </Button>
                        </Box>
                    </Box>
                </Form>
            )}
        </Formik>
    </Box>;
};

export default SMSFieldComponent;